module.exports = __webpack_public_path__ + "static/img/05.1c9bf53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/05.jpg
// module id = 444
// module chunks = 1